import React, { ReactNode } from 'react'

import { navigate } from 'gatsby'
import {
  Auth0Provider,
  type AppState,
  type User,
} from '@auth0/auth0-react'
import { ComposeProviders, ThemeProvider } from '@wicadu/arepa/ui'
import { ScannerProvider } from '@wicadu/scanner-js'

import {
  PageContextProvider,
  type PageContextType,
} from '@HOCs/Providers/PageContext'
import colors from '@constants/theme-colors'

interface Props {
  children: ReactNode
  context: PageContextType
}

function Providers({ children, context }: Props) {
  const handleOnRedirectCallback = (appState: AppState, user: User) => {
    const lang = user?.['https://wicadu.com/lang'] || 'en'
    const country = appState?.country || 'global'

    navigate(`/${lang}/${country}`, { replace: true })
  }

  return (
    <ComposeProviders
      providers={[
        [Auth0Provider, {
          domain: process.env.AUTH0_DOMAIN,
          clientId: process.env.AUTH0_CLIENT_ID,
          authorizationParams: {
            redirect_uri: `${process.env.ASSISTANT_LANDING_PAGE_HOST}/callback`,
            audience: process.env.API_GATEWAY_HOST,
          },
          onRedirectCallback: handleOnRedirectCallback
        }],
        [PageContextProvider, { context }],
        [ThemeProvider, { mode: 'LIGHT', colors }],
        ScannerProvider
      ]}
    >
      {children}
    </ComposeProviders>
  )
}

export default Providers
